import GeoReputationHome from '../views/GeoReputation/Home.vue'
import GeoReputationReputation from '../views/GeoReputation/Pages/GeoReputation.vue'
import GeoReputationDetail from '../views/GeoReputation/Pages/GeoReputationDetail.vue'


export default {
  path: '/geo-reputation',
  name: 'GeoReputationHome',
  component: GeoReputationHome,
  redirect: '/geo-reputation/reputation/:paramCOD?',
  meta: {Auth: true, isIAReputation: true},
  props: true,
  children: [
    {
      path: 'reputation/:paramCOD?',
      name: 'GeoReputationReputation',
      component: GeoReputationReputation,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'reputation-detail/:paramCOD?',
      name: 'GeoReputationDetail',
      component: GeoReputationDetail,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    }
  ]
}
